<template>
  <div class="personal-r">
    <h2>附加产品</h2>
    <table class="table-list column3">
      <tr>
        <th>名称</th>
        <th>价格</th>
        <th>适用版本</th>
      </tr>
      <tr v-for="(product, index) in productList" :key="index">
        <td>
          {{product.name}}
          <span v-if="product.allowBuy === 0">请先购买基础适用版本</span>
        </td>
        <td>
          <p v-for="price in product.productPriceVos" :key="price.month">
            <span>{{price.oriPrice | amountUnitFormat(price.month)}}</span>
            <router-link
              v-if="product.allowBuy === 1"
              :to="'/order/confirm/' + product.id + '/' + price.month"
              class="btn"
            >购买</router-link>
            <span v-if="product.allowBuy === 0" class="btn">不能购买</span>
          </p>
        </td>
        <td v-if="!product.baseProductId">所有版本</td>
        <td v-if="product.baseProductId">{{product.baseProductName}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "ExtraProduct",
  data() {
    return {
      productList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/product/extra")
        .then(response => {
          if (response.code === 0) {
            this.productList = response.data;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.column3 {
  th,
  td {
    &:first-child {
      width: 320px;
      padding: 0 45px 0 35px;
    }
    &:nth-child(2) {
      width: 330px;
    }
  }
  td {
    padding: 20px 0;
    border-bottom: 1px solid #d6d6d6;
    p {
      span {
        display: inline-block;
        width: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/ExtraProduct.vue